/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2024-03-26 09:13:19
 * @LastEditTime : 2024-09-10 09:15:28
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\basicConfig\mixForm.js
 */
import request from '@/utils/request'
export function queryRaw(data) {
  return request({
    url: '/icps/system/sign/basics/rawMaterials/queryStationMaterials',
    method: 'post',
    data
  })
}
// export function queryRaw(data) {
//   return request({
//     url: '/icps/system/sign/basics/rawMaterials/QueryPage',
//     method: 'post',
//     data
//   })
// }

// 配合比分页
export function queryMix(data) {
  return request({
    url: '/icps/quality-mix-proportion/queryPage',
    method: 'post',
    data
  })
}

// 配合比保存
export function saveMix(data) {
  return request({
    url: '/icps/quality-mix-proportion/save',
    method: 'post',
    data
  })
}